export default {
  currentTab: 0,
};
